module.exports = __webpack_public_path__ + "static/img/ta-1.057f30c.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/mobile/assets/images/partners/taboola/ta-1.png
// module id = L0+o
// module chunks = 46